<template>
  <header :class="['activity-header', displayLayout]">
    <div class="icon-wrapper space-between">
      <div class="back-icon-wrapper flex-center">
        <van-icon name="arrow-left" @click="back" v-if="!isInApp" />

        <div class="logo-wrapper flex-center">
          <img
            class="toplupe-logo"
            :src="require(`@/assets/images/common/logo.png`)"
            alt="logo"
            @click="back('home')"
          />
          <img
            class="toplupe-text"
            :src="require(`@/assets/images/common/toplupe-logo.png`)"
            alt="TOPLUPE"
            @click="back('home')"
          />
        </div>
      </div>
      <div class="share-icon-wrapper" @click="share">
        <van-image
          :src="require('@/assets/images/activities/luckydraw/icon-share.png')"
        />
        <span>{{ $t('common.share') }}</span>
      </div>
    </div>
    <MobileShare ref="mobileShare" />
  </header>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { shareShow } from '@/pages/firebase'
  import { tryToNative } from '@/utils/native'
  import hideAppBar from '@/mixins/hideAppBar'
  import { MobileShare } from '@/components/PublicShare/index'

  export default {
    mixins: [hideAppBar],
    components: {
      MobileShare,
    },
    props: {
      page: {
        type: String,
        default: '',
      },
      title: {
        default: '',
        type: String,
      },
    },
    computed: {
      ...mapGetters(['displayLayout']),
    },
    data() {
      return {
        isInApp: false,
      }
    },
    mounted() {
      this.isInApp = this.isInCoinsApp()
    },
    methods: {
      isInCoinsApp() {
        return /getcoins/i.test(window.navigator.userAgent)
      },
      back(val) {
        if (val === 'home') {
          tryToNative({
            url: 'home',
            params: null,
          }).catch(() => {
            this.$router_push({
              path: '/',
              query: {
                ...this.$route.query,
              },
            })
          })
        } else {
          this.$router.go(-1)
        }
      },
      share() {
        if (this.$refs.mobileShare) {
          this.$refs.mobileShare.switch()
          this.$refs.mobileShare.setPageName('luckyDraw')
        }
        shareShow({ page: this.page }, 'van-share-sheet')
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index.scss';
  }
</style>
